import "@/api_framework/setupAxios";
import Router from "@/app/router";
import { SocketProvider } from "@/app/components/socket/SocketProvider";
import { VoiceSessionProvider } from "@/app/context/VoiceSessionContext";
import { store } from "@/app_redux/stores/root_store.ts";
import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import "./index.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Provider store={store}>
      <SocketProvider>
        <VoiceSessionProvider>
          <Router />
        </VoiceSessionProvider>
      </SocketProvider>
    </Provider>
  </React.StrictMode>,
);
